// extracted by mini-css-extract-plugin
export default {"status":"ProductStatusChip_status__xFEPi","status_draft":"ProductStatusChip_status_draft__86aZm"};